import React from 'react';

const UserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="32"
      viewBox="0 0 27 32"
    >
      <path d="M21.446 14c2.518 0.732 5.982 3.214 5.982 11.339 0 3.679-2.732 6.661-6.089 6.661h-15.25c-3.357 0-6.089-2.982-6.089-6.661 0-8.125 3.464-10.607 5.982-11.339-0.893-1.411-1.411-3.071-1.411-4.857 0-5.036 4.107-9.143 9.143-9.143s9.143 4.107 9.143 9.143c0 1.786-0.518 3.446-1.411 4.857zM13.714 2.286c-3.786 0-6.857 3.071-6.857 6.857s3.071 6.857 6.857 6.857 6.857-3.071 6.857-6.857-3.071-6.857-6.857-6.857zM21.339 29.714c2.089 0 3.804-1.946 3.804-4.375 0-5.625-1.893-9.143-5.429-9.321-1.607 1.411-3.696 2.268-6 2.268s-4.393-0.857-6-2.268c-3.536 0.179-5.429 3.696-5.429 9.321 0 2.429 1.714 4.375 3.804 4.375h15.25z"/>
    </svg>
  );
}

export default UserIcon;



// WEBPACK FOOTER //
// ./src/components/Login/svg/UserIcon.jsx